import * as yup from "yup";
import { CHECKOUT_MAXLEN } from "./checkoutFieldMaxLengths";

const DNI_VALOR_MINIMO = 1_000_000;

export const aplicarValidacionDNI = (objEsquema: yup.StringSchema): yup.StringSchema =>
    objEsquema
        .matches(/^\d*$/, "Ingresá solo números")
        .max(CHECKOUT_MAXLEN.vchDni, "El DNI puede tener como máximo 8 dígitos")
        .test(
            "dni-minimo",
            "Ingresá un DNI válido",
            (vchValor) => !vchValor || Number(vchValor) > DNI_VALOR_MINIMO,
        );

const CANTIDAD_DIGITOS_CUIT = 11;
const PONDERADORES_CUIT = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2] as const;

export const esCuitValido = (vchCuit: string | null | undefined): boolean => {
    const vchDigitos = String(vchCuit ?? "").replace(/\D/g, "");
    if (!new RegExp(`^\\d{${CANTIDAD_DIGITOS_CUIT}}$`).test(vchDigitos)) return false;

    const intSuma = PONDERADORES_CUIT.reduce(
        (intAcumulado, intPonderador, intIndice) =>
            intAcumulado + Number(vchDigitos[intIndice]) * intPonderador,
        0,
    );
    const intResto = intSuma % 11;
    const intDigitoEsperado = intResto === 0 ? 0 : 11 - intResto;

    return intDigitoEsperado !== 10 && intDigitoEsperado === Number(vchDigitos[10]);
};

export const aplicarValidacionCUIT = (objEsquema: yup.StringSchema): yup.StringSchema =>
    objEsquema
        .matches(/^\d*$/, "Ingresá solo números")
        .max(CHECKOUT_MAXLEN.vchCuit, "El CUIT ingresado no es válido")
        .test("cuit-valido", "El CUIT ingresado no es válido", (vchValor) =>
            !vchValor ? true : esCuitValido(vchValor),
        );
